'use client';

import { useLanguage } from '@/lib/LanguageContext';
import { localeNames } from '@/lib/i18n';
import { Languages } from 'lucide-react';

export function LanguageSwitcher() {
    const { locale, setLocale } = useLanguage();

    return (
        <button
            onClick={() => setLocale(locale === 'zh-CN' ? 'en-US' : 'zh-CN')}
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            aria-label="Toggle language"
        >
            <Languages className="w-4 h-4" />
            <span className="text-sm font-medium">{localeNames[locale]}</span>
        </button>
    );
}
